<template>
  <div v-if="distributions && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <MutiplePiecesPrint
      :showSinglePrint="true"
      :formater="formater"
      :datas="distributions"
    />
  </div>
</template>
<script>
import StockOuts from "@/api/stock_outs";
import PrintTemplates from "@/api/print_templates";
import MutiplePiecesPrint from "@/components/plugins/print/MutiplePiecesPrint";
import makeData from "../distributions/makeData";

export default {
  components: {
    MutiplePiecesPrint,
  },

  data: () => ({
    formater: null,
    distributions: [],
  }),

  mounted() {
    PrintTemplates.fetchOne("commonShopDistribution").then(
      function (response) {
        if (response.data.status.isOK()) {
          var formater = response.data.print_template.template;
          // formater.page_header_left = [];
          // formater.headers = [];
          // formater.title = null;
          // formater.settings.table_head_repetitive = false;
          // formater.settings.hide_page_counter = true;
          // formater.expand_columns = formater.expand_columns_bak; //.splice(0, 1);
          // formater.group_column = formater.group_column_bak;
          // formater.group_sum_columns = formater.group_sum_columns_bak; //.splice(0, 1);
          // formater.columns = formater.columns.splice(0, 7);
          // formater.sum_columns = [];
          this.formater = formater;
          //获取单据详情
          var options = JSON.parse(JSON.stringify(this.$route.query));
          if (options.status && options.status.find((s) => s == 1))
            options.status.splice(
              options.status.findIndex((s) => s == 1),
              1
            );
          StockOuts.distributionsMergePrint(options).then(
            function (response) {
              if (response.data.status.isOK()) {
                var distributions = [];
                response.data.stock_outs.forEach((stock_out) => {
                  stock_out.shop = this.$printUtils.addCitiesName(
                    stock_out.shop
                  );
                  distributions.push(makeData.processDetails(stock_out));
                });
                this.distributions = distributions;
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>